import { updatedObject } from '../../conf-utility/utility';
import * as actionCodes from '../action-type-codes';
import { forGoingPreviousStep, forInitOnRoute, forPuttingValueOnStep, forPuttingValueOnStepOther, forSaveAndNext, forSaveSelectionValue, forSaveSelectionValueOnModal } from '../lib/stepBarState.lib';
import { StepBarEachData } from '../model/stepBarEachData.model';

export interface StepBarState {
    stepArr: StepBarEachData[];
    currentStep: number;
    isGoingBack: false;
    showEditModal: false;
    newSelectedValue: string | null;
    newSelectedOther: string | null;
    selectedConfLob: string | null;
    lobVehicleData: Object,
    pldata:string | null
 }


const initialState: StepBarState = {
    stepArr: [],
    currentStep: 0,
    isGoingBack: false,
    showEditModal: false,
    newSelectedValue: null,
    newSelectedOther: null,
    selectedConfLob: null,
    lobVehicleData: {},
    pldata:null
}

export const stepBarReducer = (state = initialState, action: any): StepBarState| undefined => {
        switch (action.type) {
        case actionCodes.STEPBAR_INITIALIZE: return updatedObject(state, { stepArr: action.lobSteps, currentStep: 0 });
        case actionCodes.STEPBAR_REINITIALIZE: return updatedObject(state, { stepArr: action.newLobSteps});
        case actionCodes.STEPBAR_SAVE_AND_NEXT: return updatedObject(state, { stepArr: forSaveAndNext(state), currentStep: state.currentStep + 1 });
        case actionCodes.STEPBAR_GO_PREVIOUS_STEP: return updatedObject(state, { stepArr: forGoingPreviousStep(state), currentStep: state.currentStep - 1 });
        case actionCodes.STEPBAR_EDIT_PREVSTEP: return updatedObject(state, { currentStep: action.stepNumber, stepArr: action.updatedStepData });
        case actionCodes.STEPBAR_SAVE_SELECTION_VALUE: return updatedObject(state, { ...forSaveSelectionValue(state, action) });
        case actionCodes.STEPBAR_PUT_VALUE_ON_STEP: return updatedObject(state, { stepArr: forPuttingValueOnStep(state, action) });
        case actionCodes.STEPBAR_INIT_ON_ROUTE: return updatedObject(state, { ...forInitOnRoute(state, action), currentStep: action.stepNumber });
        case actionCodes.STEPBAR_SAVE_SELECTION_VALUE_ON_MODAL: return updatedObject(state, { ...forSaveSelectionValueOnModal(state, action) });
        case actionCodes.STEPBAR_DISMISS_MODAL: return updatedObject(state, { showEditModal: false, newSelectedValue: null});
        case actionCodes.STEPBAR_PUT_VALUE_ON_OTHER: return updatedObject(state, { stepArr: forPuttingValueOnStepOther(state, action) });
        case actionCodes.STEPBAR_SAVE_LOB: return updatedObject(state, { selectedConfLob: action.selectedLobName});
        case actionCodes.LOBDATA_SAVE_SELECTED_VALUE: return updatedObject(state, { lobVehicleData: { vehLxData: action.vehicleLxData, vehCxData: action.vehicleCxData, taggedData: action.tagData }});
        case actionCodes.RESET_ALL_STATE: return initialState;
        case actionCodes.STEPBAR_STATE_REINIT: return updatedObject(state, {...action.newStateData});
        default: return state;
    }
}

export const getStepBarState = (state: any) => state.stepBarState;
